export default __webpack_public_path__ + "static/media/gal3.ab567e5f.jpg";